 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import LOVE_1 from '@/components/love_1'
 import ELMERGANTRY2 from '@/components/ElmerGantry-2'
 import ELMERGANTRY3 from '@/components/ElmerGantry-3'
 import ELMERGANTRY4 from '@/components/ElmerGantry-4'
 import ELMERGANTRY5 from '@/components/ElmerGantry-5'
 import ELMERGANTRY6 from '@/components/ElmerGantry-6'
 import ELMERGANTRY7 from '@/components/ElmerGantry-7'
 import ELMERGANTRY8 from '@/components/ElmerGantry-8'
 import ELMERGANTRY9 from '@/components/ElmerGantry-9'
 import ELMERGANTRY10 from '@/components/ElmerGantry-10'
 import ELMERGANTRY11 from '@/components/ElmerGantry-11'
 import ELMERGANTRY12 from '@/components/ElmerGantry-12'
 import ELMERGANTRY13 from '@/components/ElmerGantry-13'
 import ELMERGANTRY14 from '@/components/ElmerGantry-14'
 import ELMERGANTRY15 from '@/components/ElmerGantry-15'
 import ELMERGANTRY16 from '@/components/ElmerGantry-16'
 import ELMERGANTRY17 from '@/components/ElmerGantry-17'
 import ELMERGANTRY18 from '@/components/ElmerGantry-18'
 import ELMERGANTRY19 from '@/components/ElmerGantry-19'
 import ELMERGANTRY20 from '@/components/ElmerGantry-20'
 import ELMERGANTRY21 from '@/components/ElmerGantry-21'
 import ELMERGANTRY22 from '@/components/ElmerGantry-22'
 import ELMERGANTRY23 from '@/components/ElmerGantry-23'
 import ELMERGANTRY24 from '@/components/ElmerGantry-24'
 import ELMERGANTRY25 from '@/components/ElmerGantry-25'
 import ELMERGANTRY26 from '@/components/ElmerGantry-26'
 import ELMERGANTRY27 from '@/components/ElmerGantry-27'
 import ELMERGANTRY28 from '@/components/ElmerGantry-28'
 import ELMERGANTRY29 from '@/components/ElmerGantry-29'
 import ELMERGANTRY30 from '@/components/ElmerGantry-30'
 import ELMERGANTRY31 from '@/components/ElmerGantry-31'
 import ELMERGANTRY32 from '@/components/ElmerGantry-32'
 import ELMERGANTRY33 from '@/components/ElmerGantry-33'
 import ELMERGANTRY34 from '@/components/ElmerGantry-34'
 import ELMERGANTRY35 from '@/components/ElmerGantry-35'
 import ELMERGANTRY36 from '@/components/ElmerGantry-36'
 import LOVE_2 from '@/components/love_2'
 import AUBA from '@/components/auba'
 import COPYRIGHT from '@/components/Copyright'
 import ORIMAD from '@/components/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/ElmerGantry-2",
 			"name" : "ElmerGantry-2",
 			"component" : ELMERGANTRY2
 		},
 		{
 			"path" : "/ElmerGantry-3",
 			"name" : "ElmerGantry-3",
 			"component" : ELMERGANTRY3
 		},
 		{
 			"path" : "/ElmerGantry-4",
 			"name" : "ElmerGantry-4",
 			"component" : ELMERGANTRY4
 		},
 		{
 			"path" : "/ElmerGantry-5",
 			"name" : "ElmerGantry-5",
 			"component" : ELMERGANTRY5
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js